//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DictManagementData',
  data() {
    return {
      filterForm: {
        name: '', // 字典标签
      },
      dictName: '',
      dicts: [],
      tableLoading: false,
      handleType: 'add',
      dialogRemoveVisible: false,
      removeName: '',
      rowId: '',
      addOrUpdateDict: {
        dialogShow: false,
        title: '添加字典',
        loading: false,
        model: {
          name: '',
          parentId: 0,
          code: '',
          level: 1,
          disable: 0,
          remark: '',
          orderNum: 0,
        },
        rules: {
          name: [
            { required: true, message: '请输入字典标签', trigger: 'blur' },
          ],

          code: [
            {
              required: true,
              message: '请输入字典编码',
              trigger: 'blur',
            },
            {
              pattern: /^[0-9A-Za-z]{0,20}$/g,
              message: '字典编码为数字或字母，最大长度为20位',
              trigger: 'change',
            },
          ],
        },
      }, //添加和修改字典配置
    }
  },
  mounted() {
    this.addOrUpdateDict.model.parentId = this.$route.query.id
    this.dictName = this.$route.query.name
    this.getDictList()
  },
  methods: {
    /**
     * @description: 查询字典
     * @Author: quwandong
     * @Date: 2022-05-30 15:26:45
     */
    handleFilterDict() {
      this.getDictList()
    },
    /**
     * @description: 重置 搜索条件
     * @param {*} formName 表单ref
     * @Author: quwandong
     * @Date: 2022-05-30 15:37:44
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.getDictList()
    },
    /**
     * @description: 获取字典列表
     * @Author: quwandong
     * @Date: 2022-05-30 15:54:01
     */
    async getDictList() {
      try {
        this.tableLoading = true
        const params = { id: this.$route.query.id }
        const res = await this.$http.dict.getDictDataById(params)
        this.dicts = res.data
      } catch (error) {
        this.$message.error('获取失败')
      } finally {
        this.tableLoading = false
      }
    },
    /**
     * @descripttion: 添加字典
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     */
    handleAddDict() {
      this.addOrUpdateDict.dialogShow = true
      this.addOrUpdateDict.title = '添加字典'
      this.handleType = 'add'
      this.addOrUpdateDict.model = {
        name: '',
        parentId: this.$route.query.id,
        code: '',
        level: 1,
        disable: 0,
        remark: '',
        orderNum: 0,
      }
    },
    /**
     * @descripttion: 添加字典确认
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     */
    addDictConfirm() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          try {
            this.addOrUpdateDict.loading = true
            const { name, parentId, code, level, remark, orderNum } =
              this.addOrUpdateDict.model
            const params = {
              name,
              parentId,
              code,
              orderNum,
              level,
              remark,
            }
            await this.$http.dict.insertDict(params)

            this.$message.success('添加成功')
            this.getDictList()
            this.addOrUpdateDict.dialogShow = false
          } catch (error) {
            this.$message.error(error.message || '添加失败')
          } finally {
            this.addOrUpdateDict.loading = false
          }
        }
      })
    },
    /**
     * @descripttion: 添加字典弹框关闭事件
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     */
    onAddDictDialogClosed() {
      this.$refs.addForm.resetFields()
    },

    /**
     * @description: 修改字典状态
     * @param {*} row 当前数据
     * @Author: quwandong
     * @Date: 2022-05-30 16:00:06
     */
    changeDictStatus(row) {
      const type = row.disable == 1 ? '启用' : '停用'
      const msg = `是否确认${type}字典“${row.name}”?`
      const status = row.disable == 1 ? 0 : 1

      this.$confirm(msg, `${type}提示`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await this.$http.dict.updatDict({
            id: row.id,
            disable: status,
          })

          this.$message.success(`${type}成功`)
          this.getDictList()
        })
        .catch(() => {})
    },
    /**
     * @description: 修改字典
     * @param {*} item
     * @Author: quwandong
     * @Date: 2022-05-30 16:07:59
     */
    handleUpdateDict(row) {
      this.addOrUpdateDict.dialogShow = true
      this.addOrUpdateDict.title = '修改字典'
      this.addOrUpdateDict.model = { ...row }
      this.handleType = 'edit'
    },
    /**
     * @description: 修改字典确认操作
     * @Author: quwandong
     * @Date: 2022-05-30 17:49:31
     */
    async editDictConfirm() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          try {
            this.addOrUpdateDict.loading = true
            const { id, name, parentId, code, level, remark, orderNum } =
              this.addOrUpdateDict.model
            const params = {
              id,
              name,
              parentId,
              code,
              orderNum,
              level,
              remark,
            }
            await this.$http.dict.updatDict(params)

            this.$message.success('修改成功')
            this.getDictList()
            this.addOrUpdateDict.dialogShow = false
          } catch (error) {
            this.$message.error(error.message || '修改失败')
          } finally {
            this.addOrUpdateDict.loading = false
          }
        }
      })
    },
    /**
     * @description: 删除字典
     * @Author: quwandong
     * @Date: 2022-05-30 17:49:31
     */
    handleRemoveDict(row) {
      this.removeName = row.name
      this.rowId = row.id
      this.dialogRemoveVisible = true
    },
    async handleRemoveDictConfirm() {
      try {
        await this.$http.dict.removeDict({
          id: this.rowId,
        })

        this.$message.success('删除成功')
        this.dialogRemoveVisible = false
        this.getDictList()
      } catch (error) {
        this.$message.error(error.message || '删除失败')
      }
    },
  },
}
